const ScrollActivator = (element) => {
  const activatableElements = element.querySelectorAll(".intersection-active");

  const main = () => {
    if (!activatableElements?.length) {
      return;
    }

    const forceLayout = () => {
      element.style.transform = 'translateZ(0)';
      requestAnimationFrame(() => {
        element.style.transform = '';
      });
    };

    const options = {
      root: null,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio > 0) {
          requestAnimationFrame(() => {
            activatableElements.forEach((childElement) => {
              childElement.classList.add("active");
            });
          });

          observer.unobserve(entry.target);
        }
      });
    }, options);

    forceLayout();

    setTimeout(() => {
      observer.observe(element);
    }, 100);

    return () => {
      observer.disconnect();
    };
  };

  const fallbackScroll = () => {
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    
    if (rect.top <= windowHeight * 0.9) {
      activatableElements.forEach((childElement) => {
        childElement.classList.add("active");
      });
      window.removeEventListener('scroll', fallbackScroll);
    }
  };

  window.addEventListener('scroll', fallbackScroll, { passive: true });

  main();
};

export default ScrollActivator;
